import {SceneJsonImporter} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/io/json/import/Scene';
import {PolyScene} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/scene/PolyScene';

import {EngineExtendedAllRegister} from './registers';

// import {EngineMiniAllRegister} from './registers_mini';
// EngineMiniAllRegister.run();

export {PolyScene, SceneJsonImporter};

import {loadFromElementDataset, waitForDocumentLoaded} from './index_common';

async function start() {
	const promises = [waitForDocumentLoaded(), EngineExtendedAllRegister.run()];
	await Promise.all(promises);
	// await EngineExtendedAllRegister.run();
	loadFromElementDataset();
}
start();
